import React from "react";
import { Container, Row, Col } from "reactstrap";
import { } from "pages/redux/actions";

const UserHeader = (props) => {
  // const id = props.id
  // console.log(id)
  return (
    <>
      <div
        className="header pb-8 pt-4 pt-lg-6 d-flex align-items-center bg-gradient-blcue"
        style={{
          minHeight: "100px",
        }}
      >
        {/* Mask */}
        <span className="" />
        {/* Header container */}
        <Container className="d-flex align-items-center" fluid>
          <Row>
            <Col lg="7" md="10">
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default UserHeader;
